import axios from 'axios';

declare module 'axios' {
  export interface AxiosRequestConfig {
    requireAuth?: boolean;
  }
}

const instance = axios.create({
  baseURL: `/`,
});

instance.defaults.headers['Accept-Language'] = 'is';
instance.defaults.xsrfHeaderName = 'X-CSRFToken';
instance.defaults.xsrfCookieName = 'csrftoken';
instance.defaults.withCredentials = true;

export default instance;
